// "Your garage": what a visitor has looked at, saved on this device only
// (localStorage, no account, nothing sent anywhere). Every read and write is
// wrapped so private mode or blocked storage just means an empty garage.
const KEY = 'fi-garage-v1';
const EVENT = 'fi:garage';

export function readGarage() {
  try {
    const raw = window.localStorage.getItem(KEY);
    const g = raw ? JSON.parse(raw) : {};
    return {
      shortlist: Array.isArray(g.shortlist) ? g.shortlist : [],
      quotes: Array.isArray(g.quotes) ? g.quotes : [],
      state: g.state || null,
      updatedAt: g.updatedAt || null,
    };
  } catch (_) {
    return { shortlist: [], quotes: [], state: null, updatedAt: null };
  }
}

function writeGarage(patch) {
  try {
    const next = { ...readGarage(), ...patch, updatedAt: Date.now() };
    window.localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new Event(EVENT));
    return next;
  } catch (_) {
    return null;
  }
}

export const onGarageChange = (fn) => {
  window.addEventListener(EVENT, fn);
  window.addEventListener('storage', fn);
  return () => {
    window.removeEventListener(EVENT, fn);
    window.removeEventListener('storage', fn);
  };
};

export const isShortlisted = (slug) => readGarage().shortlist.some((c) => c.slug === slug);

export function toggleShortlist({ slug, name }) {
  const { shortlist } = readGarage();
  const has = shortlist.some((c) => c.slug === slug);
  const next = has ? shortlist.filter((c) => c.slug !== slug) : [...shortlist, { slug, name }].slice(-6);
  writeGarage({ shortlist: next });
  if (window.gtag) window.gtag('event', 'garage_shortlist', { slug, on: !has });
  return !has;
}

// A Deal-Checker run: how many junk lines were flagged and their cost range.
export function saveQuoteCheck({ flagged, low, high, deadCredit }) {
  const { quotes } = readGarage();
  writeGarage({ quotes: [...quotes, { flagged, low, high, deadCredit: !!deadCredit, at: Date.now() }].slice(-5) });
}

export function saveState({ slug, name }) {
  writeGarage({ state: { slug, name } });
}
